import React, { useState } from "react";
import FormSecretKey from "./FormSecretKey";
import { Typography } from "@mui/material";
import ModalBox from "../../ui/ModalBox";
import { useNavigate } from "react-router-dom";

const AddSecretKeys = () => {
  const [open, setOpen] = useState(false);
  //var to navigate another page

  const navigate = useNavigate();
  // close modal function

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  //open modal function

  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Add Secret
      </Typography>
      <FormSecretKey handleSuccess={handleSuccess} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The add operation has been completed successfully.. You added new Secret Key"
        name="Secret Key"
      />
    </>
  );
};

export default AddSecretKeys;
